/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-arrow-up': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M7.768.561a.5.5 0 0 1 .707 0l7 7a.5.5 0 1 1-.707.708L8.62 2.122v12.793a.5.5 0 1 1-1 0V2.122L1.475 8.27a.5.5 0 0 1-.707-.708l7-7z" _fill="#A3A3A3"/>'
  }
})
